import { Injectable } from '@angular/core';
import { WebConstants } from '../util/web.constants';
import { Observable } from 'rxjs';
import { BaseResponse } from '../model/base.response';
import { AjaxHelper } from '../helper/ajax.helper';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {

  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper) { }

  getAllTicketPrice(): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.CONFIGURATION.FIND_ALL_TICKET_PRICE);
  }

  addTicketPrice(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.CONFIGURATION.ADD_TICKET_PRICE, payload);
  }

  updateTicketPrice(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.CONFIGURATION.UPDATE_TICKET_PRICE, payload);
  }

  deleteTicketPrice(ticketPriceId: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.CONFIGURATION.DELETE_TICKET_PRICE + ticketPriceId);
  }

}
